import React, { FC, RefObject } from 'react';

import { makeInfoPageRoute } from '@utils/route';

import { Button } from '@components/common/Button/Button';
import { Link } from '@components/common/Link/Link';

import styles from './CookieConsent.module.scss';

export const DEFAULT_COOKIE_BANNER_TEXT =
    'Мы используем файлы cookie, чтобы сайт работал корректно, а навигация была удобнее. ' +
    'Аналитические cookie помогают нам улучшать сервис. Вы можете принять или отклонить их использование.';

export const getCookieBannerText = (value: string | null | undefined): string => {
    if (typeof value === 'string' && value.trim().length > 0) return value;
    return DEFAULT_COOKIE_BANNER_TEXT;
};

type CookieConsentViewProps = {
    text: string;
    onAccept: () => void;
    onDecline: () => void;
    panelRef?: RefObject<HTMLElement>;
};

export const CookieConsentView: FC<CookieConsentViewProps> = (props) => {
    const { text, onAccept, onDecline, panelRef } = props;

    return (
        <section
            ref={panelRef}
            className={styles.root}
            aria-label="Настройки файлов cookie"
            data-testid="cookie-consent"
            tabIndex={-1}
        >
            <span className={styles.icon} aria-hidden="true" />
            <div className={styles.content}>
                <div className={styles.textBlock}>
                    <p className={styles.text}>{text}</p>
                    <Link
                        route={makeInfoPageRoute('privacy')}
                        className={styles.privacyLink}
                        data-testid="cookie-privacy-link"
                    >
                        Политика конфиденциальности
                    </Link>
                </div>
            </div>
            <div className={styles.actions}>
                <Button
                    variant="green"
                    size="normal"
                    isFullWith
                    onClick={onAccept}
                    data-testid="cookie-accept"
                >
                    Принять
                </Button>
                <Button
                    variant="white"
                    size="normal"
                    isFullWith
                    onClick={onDecline}
                    data-testid="cookie-decline"
                >
                    Отклонить
                </Button>
            </div>
        </section>
    );
};
